import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

// Public
export const submitEnquiry = (data) => axios.post(`${API}/enquiries`, data);
export const fetchPackages = () => axios.get(`${API}/packages`);

// Auth
export const login = (email, password) => axios.post(`${API}/auth/login`, { email, password });
export const fetchMe = (token) => axios.get(`${API}/auth/me`, authHeader(token));

// Admin — enquiries
export const fetchEnquiries = (token) => axios.get(`${API}/enquiries`, authHeader(token));
export const fetchStats = (token) => axios.get(`${API}/enquiries/stats`, authHeader(token));
export const updateEnquiryStatus = (id, status, token) =>
  axios.patch(`${API}/enquiries/${id}`, { status }, authHeader(token));

// Admin — packages
export const createPackage = (data, token) => axios.post(`${API}/packages`, data, authHeader(token));
export const updatePackage = (id, data, token) => axios.put(`${API}/packages/${id}`, data, authHeader(token));
export const deletePackage = (id, token) => axios.delete(`${API}/packages/${id}`, authHeader(token));

// Shop — public
export const fetchShopProducts = () => axios.get(`${API}/shop/products`);
export const fetchShopProduct = (slug) => axios.get(`${API}/shop/products/${slug}`);
export const fetchShopSettings = () => axios.get(`${API}/shop/settings`);

// Shop — customer accounts
export const customerRegister = (data) => axios.post(`${API}/shop/auth/register`, data);
export const customerLogin = (email, password) => axios.post(`${API}/shop/auth/login`, { email, password });
export const fetchCustomerMe = (token) => axios.get(`${API}/shop/auth/me`, authHeader(token));
export const fetchMyOrders = (token) => axios.get(`${API}/shop/orders`, authHeader(token));
export const cancelSubscription = (orderId, token) =>
  axios.post(`${API}/shop/subscriptions/${orderId}/cancel`, {}, authHeader(token));

// Shop — checkout
export const createCheckout = (payload, token) => axios.post(`${API}/shop/checkout`, payload, authHeader(token));
export const fetchPaymentStatus = (sessionId) => axios.get(`${API}/payments/status/${sessionId}`);

// Admin — shop
export const adminProducts = (token) => axios.get(`${API}/admin/products`, authHeader(token));
export const adminCreateProduct = (data, token) => axios.post(`${API}/admin/products`, data, authHeader(token));
export const adminUpdateProduct = (id, data, token) => axios.put(`${API}/admin/products/${id}`, data, authHeader(token));
export const adminDeleteProduct = (id, token) => axios.delete(`${API}/admin/products/${id}`, authHeader(token));
export const adminOrders = (token) => axios.get(`${API}/admin/orders`, authHeader(token));
export const adminOrderStats = (token) => axios.get(`${API}/admin/orders/stats`, authHeader(token));
export const adminUpdateOrder = (id, data, token) => axios.patch(`${API}/admin/orders/${id}`, data, authHeader(token));
export const adminSettings = (token) => axios.get(`${API}/admin/settings`, authHeader(token));
export const adminSaveSettings = (data, token) => axios.put(`${API}/admin/settings`, data, authHeader(token));
export const adminCustomers = (token) => axios.get(`${API}/admin/customers`, authHeader(token));
